import { Component } from '@angular/core';

/** Blinking dot shown once at the end of in-progress streamed assistant text (RIA). */
@Component({
  selector: 'app-agent-streaming-cursor',
  templateUrl: './agent-streaming-cursor.component.html',
  styleUrls: ['./agent-streaming-cursor.component.scss']
})
export class AgentStreamingCursorComponent {}
